import api from "../../services/api";

export const createExam = async (payload, idempotencyKey) => {
  const response = await api.post("teacher/exams/", payload, {
    headers: { "Idempotency-Key": idempotencyKey },
  });
  return { data: response.data, httpStatus: response.status };
};

export const getExamStatus = async (examId) => {
  const response = await api.get(`teacher/exams/${examId}/`);
  return response.data;
};

export const previewExam = async (payload) => {
  const response = await api.post("teacher/exams/preview/", payload, {
    responseType: "blob",
  });
  return response.data;
};

export const payExamWithWallet = async (examId) => {
  const response = await api.post(`teacher/exams/${examId}/pay/`, {}, {
    // Un POST financier ne doit jamais être rejoué automatiquement après un 401.
    skipAuthRetry: true,
  });
  return response.data;
};

export const initializeCinetPayPayment = async (examId, idempotencyKey) => {
  const response = await api.post(`teacher/exams/${examId}/pay/cinetpay/`, {
    idempotency_key: idempotencyKey,
  }, {
    // Limite propre à l'initialisation externe : l'instance Axios globale reste inchangée.
    timeout: 40000,
    // Un POST de paiement ne doit jamais être rejoué automatiquement après un 401.
    skipAuthRetry: true,
  });
  return response.data;
};

export const getCinetPayPaymentStatus = async (examId) => {
  const response = await api.get(`teacher/exams/${examId}/payment-status/`);
  return response.data;
};
